import { render } from "./ChatFooter.vue?vue&type=template&id=1722d0ef&scoped=true"
import script from "./ChatFooter.vue?vue&type=script&lang=js"
export * from "./ChatFooter.vue?vue&type=script&lang=js"

import "./ChatFooter.vue?vue&type=style&index=0&id=1722d0ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1722d0ef"]])

export default __exports__